import Vue from 'vue';
import { VBTooltip, BCollapse, VBToggle, BDropdown, BDropdownItem, BButton } from 'bootstrap-vue';
import Flickity from '../vendor/catapult/Vue/components/vue-flickity.js';
import Isotope from 'isotope-layout';

import { ValidationProvider, ValidationObserver, localize, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import nl from 'vee-validate/dist/locale/nl.json';
localize('nl', nl);
extend('required', required)
extend('email', email)

import lodash from 'lodash';
// import axios from 'axios';
import axios from 'axios/dist/axios.js'

import hashanimate from '../vendor/catapult/Vue/components/hash-animate.js';
import GoogleMaps from '../vendor/catapult/Vue/components/google-maps.js';
import intersectionObserver from '../vendor/catapult/Vue/components/intersection-observer.js';
import svgViewer from '../vendor/catapult/Vue/components/svg-viewer/svg-viewer.js';

const SiteVue = {

  vuePage : null,
  vueMenu : null,
  vueFooter : null,

  destroyPageVue: function destroyPageVue(){
    if (SiteVue.vuePage != null) SiteVue.vuePage.$destroy();
  },

  initPageVue: function initPageVue($container) {

    if ($container) {
      var elm = $container.querySelector('#content-page');
    }
    else{
      var elm = '#content-page';
    }

        SiteVue.vuePage = new Vue({
          el: elm,
          data() {
            return {
              page_color:null,
              nav_color:null,
              base_url: window.base_url,
              selected: null,
              maxCount: 140,
              remainingCount: 140,
              message: '',
              hasError: false,
              show_image_popup: false,
              isoGrid: null
            }
          },
          components: {
              Flickity,
              BCollapse,
              BButton,
              BDropdown,
              BDropdownItem,
              GoogleMaps,
              svgViewer
          },
          directives: {
              'b-toggle' : VBToggle,
              'b-tooltip' : VBTooltip,
              'hashanimate' : hashanimate,
              intersectionObserver
          },
          created: function created(){
          },
          computed: {
          },
          watch: {
          },
          mounted: function(){

            this.loadVisibleVideos();

          },
          methods: {

            loadVisibleVideos() {

                $('.video-load-visible').each(
                    function( index ){
                      const bgv = $(this);

                      if (bgv.is(':visible')) {
                        $('source', bgv).each(
                          function() {
                            const el = $(this);
                            el.attr('src', el.data('src'));
                          }
                        );

                        bgv[0].load();
                      }
                });

            },

            setupPage: function(pageinfo){
              this.removeBodyClass("dark");
              this.removeBodyClass("light");
              this.removeBodyClass("nav-dark");
              this.removeBodyClass("nav-light");
              this.page_color = pageinfo.page_color;
              this.nav_color  = pageinfo.nav_color;
              this.addBodyClass(this.page_color);
              this.addBodyClass('nav-'+this.nav_color);

              this.loadIsotope();
              console.log(pageinfo);
            },

            removeBodyClass: function (class_name) {
              $("body").removeClass(class_name);
            },

            addBodyClass: function (class_name) {
              $("body").addClass(class_name);
            },

            toggleImageSlidePopup: function () {
              this.show_image_popup = !this.show_image_popup;
              if (this.show_image_popup)  {
                this.$nextTick(() => {
                  this.$refs.flickityImagePopup.resize();
                })
              }
            },

            loadIsotope: function (){
              var grid = document.getElementsByClassName('grid');
              if (grid.length > 0) {
                this.isoGrid = new Isotope('.grid', {
                    "itemSelector": ".grid-item",
                    "masonry": { }
                });
              }
            },

            onFlickityInit: function (flickity){
              console.log('flickity init', flickity);
              var _this = this;
              flickity.on( 'lazyLoad', function( event, cellElement ) {
                console.log('lazyload',event);
                if (_this.isoGrid)
                _this.isoGrid.layout();
              });
            }



          },

        })
  },


  initMenuVue: function initMenu() {
    SiteVue.vueMenu = new Vue({
    el: '#menuVue',
      data:{
          searchMenuActive:false,
          showMenu: false,
          typing:false,
          searching:false,
          searchQuery:'',
          view:null,
          path:[],
          lang:null,
          auth_user:null,
          activeItemPath:'',
          activeItemView:'',
          menuHeight:0,

          mobileMenuActive: false,

          newsletter : {
            email:null,
            opt_in:null
          },

          results: {
            'total': 0,
            'results': {}
          }
      },
      components: {
          BCollapse,
          ValidationObserver,
          ValidationProvider,
      },
      directives: {
          'b-toggle' : VBToggle,
          'b-tooltip': VBTooltip
      },

      created: function(){
      },

      watch: {

        mobileMenuActive: function searchQuery(after, before) {
          if (after){
            $("body, html").addClass("no-scroll");
          }
          else{
             $("body, html").removeClass("no-scroll");
          }
        },

        searchQuery: function searchQuery(after, before) {

          if (after == ''){
            this.clearResults();
          }
          else {
            this.typing = true;
            this.doSearch();
          }
        }
      },

      methods: {
        setupMenu: function(pageinfo){
          this.view = pageinfo.view;
          this.path = pageinfo.path;
          this.lang = pageinfo.lang;
          this.auth_user = pageinfo.auth_user;
          this.mobileMenuActive = false;
      //    this.activeItemPath = this.path[0];
      //    this.activeItemView = this.view;
          if (this.view == 'homepage') {
            $("body").addClass('homepage');
          }
          else{
            $("body").removeClass('homepage');
          }
        },

        showSubMenu: function(subMenuId){
          console.log('showSubMenu');
          this.menuHeight = '200px';
        },

        hideSubMenu: function(){
          console.log('hideSubMenu');
          this.menuHeight = 0;
        },

        setMenu: function(index,val){
          this.$set(this.path, index, val);
          for (var i = index+1; i < this.path.length; i++) {
            this.$delete(this.path, i);
          }
          console.log('path',this.path);

        },

        mobileMenu: function (status) {
          this.mobileMenuActive = !this.mobileMenuActive;
          if (status) {
            $("body").addClass('no-scroll');
          }
          else{
            $("body").removeClass('no-scroll');
          }
        },

        searchMenu: function (status) {
          this.searchMenuActive = !this.searchMenuActive;
          if (status) {
            $("body").addClass('searchMenuActive');
          }
          else{
            $("body").removeClass('searchMenuActive');
          }
        },

        setShowMenu: function(status){
          this.showMenu = status;
        },


        clearResults: function(){
          this.results = {
            'total': 0,
            'results': {}
          }
        },

        onSubmit () {
          console.log('this.$refs.form.validate()',this.$refs.form.validate());

          this.$refs.form.validate().then(success => {
            if (!success) {
              return;
            }
            this.$refs.formelement.submit();
          });
        },

        doSearch: lodash.debounce(function() {
          var _this = this;
          var url = base_url+"/api/search";
          this.typing = false;
          if (this.searchQuery!=''){
              this.searching = true;
              axios.get(url, {
                params: {
                  query: this.searchQuery,
                  perpage: 6
                }
              }).then(function (response) {
                _this.searching = false;
                return _this.results = response.data;
              }).catch(function (error) {
                _this.searching = false;
              });
          }
        }, 500)


      }



    })
  },



  initFooterVue: function initFooterVue() {

      var elm = '#footer';

        SiteVue.vueFooter = new Vue({
          el: elm,
          data() {
            return {
              newsletter : {
                email:null,
                opt_in:null
              }
            }
          },
          components: {
            ValidationObserver,
            ValidationProvider,
          },
          directives: {
            intersectionObserver
          },
          created: function created(){
          },
          computed: {
          },
          watch: {
          },
          mounted: function(){

          },
          methods: {
            onSubmit () {
              console.log('this.$refs.form.validate()',this.$refs.form.validate());

              this.$refs.form.validate().then(success => {
                if (!success) {
                  return;
                }
                this.$refs.formelement.submit();
              });
            }

          },

        });
  }



};

export default SiteVue;
